import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { PUNCTUATION_MARKS_CONSTANTS } from '../../common/constants/constants';
import { useOnMobile } from '../../common/hooks/breakpoints';

export default ({
    text,
    width = 100,
    color = undefined
}: {
    text: string | string[];
    width?: number;
    color?: string;
}) => {
    const isMobile = useOnMobile();
    const content = Array.isArray(text) ? text.join(`${PUNCTUATION_MARKS_CONSTANTS.comma} `) : text;

    return (
        <Tooltip title={<Typography fontSize="small">{content}</Typography>}>
            <Typography maxWidth={isMobile ? width : 'auto'} color={color || 'currentColor'}>
                {content}
            </Typography>
        </Tooltip>
    );
};
